<template>
  <div class="control-panel">
    <div class="controls">
      <div class="row">
        <label>Outline</label>
        <input :value="value.outline" @input="update('outline', $event.target.value)" type="range" min="0" max="8.0" step="0.1">
      </div>
      <div class="row">
        <label>Turn</label>
        <input :value="value.squiggleTurn" @input="update('squiggleTurn', $event.target.value)" type="range" min="0" max="2.0" step="0.1">
      </div>
      <div class="row">
        <label>Skew</label>
        <input :value="value.squiggleSkew" @input="update('squiggleSkew', $event.target.value)" type="range" min="-0.5" max="0.5" step="0.05">
      </div>
      <div class="row">
        <label>Length</label>
        <input :value="value.squiggleLength" @input="update('squiggleLength', $event.target.value)" type="range" min="0.05" max="2.0" step="0.05">
      </div>
      <div class="row">
        <label>Shading</label>
        <input :value="value.squiggleShading" @input="update('squiggleShading', $event.target.value)" type="range" min="0" max="4.0" step="0.1">
      </div>
      <div class="row checkbox-row">
        <div class="checkbox-control">
          <input type="checkbox" name="eyeChecked" id="eyeChecked" v-model="eyeChecked">
          <label for="eyeChecked">Eyes</label>
        </div>


        <div class="checkbox-control">
          <input type="checkbox" id="noseChecked" name="noseChecked" v-model="noseChecked">
          <label for="noseChecked">Nose</label>
        </div>

        <div class="checkbox-control">
          <input type="checkbox" id="mouthChecked" name="mouthChecked" v-model="mouthChecked">
          <label for="mouthChecked">Mouth</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "control-panel",
  props: ['value'],
  data () {
    return {
      eyeChecked: this.value.eyes,
      noseChecked: this.value.nose,
      mouthChecked: this.value.mouth
    }
  },
  watch: {
    eyeChecked (value) {
      this.update('eyes', value)
    },
    noseChecked (value) {
      this.update('nose', value)
    },
    mouthChecked (value) {
      this.update('mouth', value)
    }
  },
  methods: {
    update (key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    }
  }
}
</script>

<style lang="scss" scoped>
  $range-track-color: $color-grey;
  $range-track-width: 3px;
  $range-slider-color: $color-red;
  $range-slider-width: 15px;


  .control-panel {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: $color-white;

    .controls {
      height: calc(100% - 30px);
      max-height: 260px;
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      // justify-content: center;
      justify-items: stretch;
      align-items: center;
      align-content: stretch;
    }

    .row {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      flex-grow: 1;
      padding: 0 30px;
      width: calc(100% - 60px);

      label {
        display: block;
        margin-right: 1em;
        text-align: right;
        width: calc(25% - 1em);
      }

      input[type=range] {
        width: 75%;
        background: transparent;
      }

      input[type=range] {
        -webkit-appearance: none;
        height: 20px;
        width: 100%;
      }
      input[type=range]:focus {
        outline: none;
      }
      input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: $range-track-width;
        cursor: pointer;
        box-shadow: none;
        background: $range-track-color;
        border-radius: 1.3px;
        border: none;
      }
      input[type=range]::-webkit-slider-thumb {
        box-shadow: none;
        border: none;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        background: $color-red;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -6px;
      }
      input[type=range]:focus::-webkit-slider-runnable-track {
        background: $range-track-color;
      }
      input[type=range]::-moz-range-track {
        width: 100%;
        height: $range-track-width;
        cursor: pointer;
        background: $range-track-color;

      }
      input[type=range]::-moz-range-thumb {
        height: $range-slider-width;
        width: $range-slider-width;
        border-radius: 50%;
        background: $range-slider-color;
        border: none;
        cursor: pointer;
      }
      input[type=range]::-ms-track {
        width: 100%;
        height: $range-track-width;
        cursor: pointer;
        background: transparent;
        border: none;
        color: transparent;
      }
      input[type=range]::-ms-fill-lower {
        background: $range-track-color;
        border: none;
        border-radius: 0;
        box-shadow: none;
      }
      input[type=range]::-ms-fill-upper {
        background: $range-track-color;
        border: none;
        border-radius: 0;
        box-shadow: none;
      }
      input[type=range]::-ms-thumb {
        box-shadow: none;
        border: none;
        height: $range-slider-width;
        width: $range-slider-width;
        border-radius: 50%;
        background: $range-slider-color;
        cursor: pointer;
      }
      input[type=range]:focus::-ms-fill-lower {
        background: $range-track-color;
      }
      input[type=range]:focus::-ms-fill-upper {
        background: $range-track-color;
      }

    }

    .checkbox-row {
      justify-content: flex-start;
      padding-left: calc(25%);
      width: calc(75% - 2em);

      @media screen and (max-width: $break-mobile) {
        justify-content: space-between;
        padding-left: 0;
      }

      .checkbox-control {
        position: relative;
        white-space: nowrap;
        padding-right: 3em;

        @media screen and (max-width: $break-mobile) {
          padding-right: 0;
        }

        &:last-child {
          label {
            margin-right: 0;
            padding-right: 0;
          }
        }
      }

      input[type=checkbox] {
        opacity: 0;

        + label {
          display: initial;
          cursor: pointer;
          padding-left: 0.5em;

          &:before {
            content: "";
            position: absolute;
            top: 1px;
            left: 0;
            display: block;
            height: calc(1em - 4px);
            width: calc(1em - 4px);
            padding: 3px;
            border-radius: 50%;
            border: solid 2px $color-red;
            background-color: $color-white;
            transition: background-color ease-in-out 0.2s;
          }
        }

        &:checked + label:before {
          background-clip: content-box;
          background-color: $color-red;
        }

      }
    }
  }
</style>
